import resources from '../resource.js';

const resource = 'application/directors';

export default {
    show(id) {
        return resources.get(`${resource}/${id}`);
    },
}
